export default __webpack_public_path__ + "static/wallpaper-4-pc-2664467a558015b67924625158ca3501.png";